(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxErrorHelpDirective(
    $timeout, $filter, toastr, $http, $window, $rootScope, APIAdmin
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        meta: '=meta',
        me: '=me',
        error: '=error',
        callback: '&callback'
      },
      templateUrl: 'app/directives/error-help-directive/error-help.template.html',
      link: function(scope) {

        scope.captionTranslated = null;
        scope.caption = null;

        (() => {
          translateErrorMessage()
          setPosition()
        })();

        function translateErrorMessage () {
          scope.captionTranslated = $filter('translate')(scope.error.data.errorCode)
          if (scope.captionTranslated === scope.error.data.errorCode) {
            scope.caption = scope.error.data.parameterizedErrorText
          } else {
            scope.caption = scope.captionTranslated;
          }

          scope.error.data.parameters.forEach((parameter, index) => {
            scope.caption = scope.caption.replace('{' + index + '}', parameter)
          })
        }

        scope.$on('LANGUAGE_CHANGED', () => {
          translateErrorMessage()
        })

        scope.removeAnimate = function () {
          angular.element('.px-new-error-dialog').removeClass('animate')
        }

        scope.addAnimate = function () {
          angular.element('.px-new-error-dialog').addClass('animate')
        }

        function setPosition () {
          $timeout(function() {
            var contentContainerDivs = angular.element('.context-content-container');
            var verticalCenter = 0;
            var horizontalCenter = 0;
            if (contentContainerDivs.length > 1) {
              // The penultimate match is the parent dialog window
              var parentDiv = contentContainerDivs.eq(contentContainerDivs.length - 2);
              horizontalCenter = parentDiv.innerWidth() / 2;
              verticalCenter = parentDiv.innerHeight() / 2;
            } else {
              // If the dialog has no parent, it's aligned to the center of the client area
              horizontalCenter = window.innerWidth / 2
              verticalCenter = $window.innerHeight / 2;
            }

            var dialogDiv = contentContainerDivs.last();
            var dialogHorizontalCenter = dialogDiv.innerWidth() / 2;
            var dialogVerticalCenter = dialogDiv.innerHeight() / 2;

            dialogDiv.css({
              left: horizontalCenter - dialogHorizontalCenter,
              top: verticalCenter - dialogVerticalCenter,
              display: 'block'});
          }, 50)
        }

        scope.rePosition = () => {
          $timeout(() => {
            setPosition();
          }, 150)
        }

        scope.closePopup = function () {
          scope.callback();
        }

        scope.$on('$destroy', function() {
        });

      }
    };
  }

  pxErrorHelpDirective.$inject = [
    '$timeout', '$filter', 'toastr', '$http', '$window', '$rootScope', 'APIAdmin'
  ];

  angular
    .module('printix-admin')
    .directive('pxErrorHelpDirective', pxErrorHelpDirective);

})();
